<template>
  <span :class="{ 'ac-chip--disabled': disabled }" :title="text" class="ac-chip">
    <span v-if="color" :style="{ backgroundColor: color }" aria-hidden="true" class="ac-chip__dot"></span>
    <span class="ac-chip__text">{{ text }}</span>
    <button v-if="removable && !disabled" :aria-label="`${text} entfernen`" class="ac-chip__remove" tabindex="-1"
            type="button" @click.stop.prevent="$emit('remove')" @mousedown.stop.prevent>
      <v-icon x-small>mdi-close</v-icon>
    </button>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';

/** Soft selection chip of the autocompletes (removable, optional colour dot, ellipsis for long texts) */
export default Vue.extend({
  name: 'AcChip',
  props: {
    text: {type: String, default: ''},
    color: {type: String, default: ''},
    removable: {type: Boolean, default: true},
    disabled: {type: Boolean, default: false},
  },
});
</script>

<style src="./autocomplete.css"></style>
